import { useEffect } from 'react';
import {
  Card,
  Row,
  Col,
  Form,
  DatePicker,
  Input,
  Button,
  Modal,
  message
} from 'antd';
import { headerStyle } from 'shared/styles/baseStyle';
import EndPoints from 'shared/endPoints/EndPoints.json';
import useHttpClient from 'shared/hooks/http-hook';

export default function DeleteKilometers() {
  const { RangePicker } = DatePicker;
  const { TextArea } = Input;
  const dateFormat = 'D/M/YYYY';
  const [form] = Form.useForm();
  const values = Form.useWatch([], form);
  const { status, sendRequest, errorMessage } = useHttpClient();
  const formItemLayout = {
    labelCol: {
      span: 12
    },
    wrapperCol: {
      span: 12
    }
  };

  const enabledDeleteButton =
    Boolean(values?.range) && Boolean(values?.type?.trim());

  useEffect(() => {
    if (status === 'resolved') {
      message.success('Η διαγραφή ολοκληρώθηκε επιτυχώς.');
      form.resetFields();
      return;
    }
    if (status === 'rejected') {
      form.resetFields();
    }
  }, [status, errorMessage, form]);

  const handleDelete = () => {
    const { range, type } = form.getFieldsValue();
    const [from, to] = range;
    Modal.confirm({
      title: 'Επιβεβαίωση Διαγραφής',
      content: `Είσαι σίγουρος/η ότι θέλεις να διαγραφούν τα χιλιόμετρα από ${from.format(
        dateFormat
      )} έως ${to.format(dateFormat)};`,
      okText: 'Ναι',
      cancelText: 'Ακύρωση',
      onOk: () =>
        sendRequest({
          endpoint: EndPoints.TRIPS.DELETETRIPSBYDATE,
          method: 'PUT',
          data: {
            startDate: from.format(dateFormat),
            endDate: to.format(dateFormat),
            type
          }
        })
    });
  };

  return (
    <Card
      type="inner"
      headStyle={headerStyle}
      title="Συμπληρώστε τα πεδία και στη συνέχεια πατήστε το κουμπί Διαγραφή"
    >
      <Form form={form} {...formItemLayout}>
        <Col span={10}>
          <Form.Item name="range" label="Ημερομηνία Αποστολής:">
            <RangePicker format={dateFormat} style={{ width: '150%' }} />
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item name="type" label="Αιτιολογία Διαγραφής:">
            <TextArea rows={2} style={{ width: '150%' }} />
          </Form.Item>
        </Col>
        <Row justify="center" style={{ marginTop: 80 }}>
          <Col>
            <Form.Item>
              <Button
                onClick={handleDelete}
                disabled={!enabledDeleteButton}
                style={{ backgroundColor: '#e6e6e6' }}
              >
                Διαγραφή
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
}
